import { getSyncedHealthTrackers } from "core/javascriptChannels";
import { isTrackerForPlatform, isTrackerTypePermissionAllowed, TrackerType } from "core/state/Trackers/TrackerType";
import { useEffect, useState } from "react";
import { useMobilePlatform } from "./useMobilePlatform";

export type UseMobilePlatformType = {
  requiresHealthPermission: boolean | undefined;
  loading: boolean;
};

export const useTrackerDataSync = (trackerType: TrackerType): UseMobilePlatformType => {
  const [loading, setLoading] = useState<boolean>(true);
  const { isMobileApp, platform } = useMobilePlatform();
  const [requiresHealthPermission, setRequiresHealthPermission] = useState<boolean>();

  useEffect(() => {
    async function fetchTrackerPermissionsStatus() {
      const syncedTrackers: string[] = await getSyncedHealthTrackers();
      const trackerRequiresPermission =
        platform && isTrackerForPlatform(trackerType, platform) && !isTrackerTypePermissionAllowed(trackerType, syncedTrackers);

      setRequiresHealthPermission(trackerRequiresPermission);
      setLoading(false);
    }
    if (isMobileApp) {
      fetchTrackerPermissionsStatus();
    }
  }, [isMobileApp, platform, trackerType]);

  return { requiresHealthPermission, loading };
};
